import { FileResult, ServiceResult } from '../models/api-shared.models';
import {
  CustomerSpecialOrdersExistsResult,
  GetCustomerSpecialOrdersExistsRequest,
  GetCustomerSpecialOrdersRequest,
} from '../models/customer-special-order.models';
import ApiService from './api-service';

class CustomerSpecialOrderService extends ApiService {
  private static classInstance: CustomerSpecialOrderService;

  private constructor() {
    super('CustomerSpecialOrder');
  }

  public getCustomerSpecialOrdersExists(
    request: GetCustomerSpecialOrdersExistsRequest
  ): ServiceResult<CustomerSpecialOrdersExistsResult> {
    return this.post(`${this.persistUrl}/GetCustomerSpecialOrdersExists`, request);
  }

  public getCustomerSpecialOrders(request: GetCustomerSpecialOrdersRequest): ServiceResult<FileResult> {
    return this.post(`${this.persistUrl}/GetCustomerSpecialOrders`, request);
  }

  public static getInstance(): CustomerSpecialOrderService {
    if (!this.classInstance) {
      this.classInstance = new CustomerSpecialOrderService();
    }
    return this.classInstance;
  }
}

export default CustomerSpecialOrderService;
